export enum ConditionOperators {
  equal = 'equal',
  notEqual = 'notEqual',
  notEmpty = 'notEmpty',
  empty = 'empty',
  contains = 'contains',
  notContains = 'notContains',
  greaterThanOrEqual = 'greaterThanOrEqual',
  greaterThan = 'greaterThan',
  afterOrEqual = 'afterOrEqual',
  after = 'after',
  lessThanOrEqual = 'lessThanOrEqual',
  lessThan = 'lessThan',
  beforeOrEqual = 'beforeOrEqual',
  before = 'before',
  between = 'between',
  any = 'any',
  arrayEqual = 'arrayEqual',
  arrayNotEqual = 'arrayNotEqual',
  checked = 'checked',
  notChecked = 'notChecked',
  in = 'in',
  notIn = 'notIn',
  isDateNewerThan = 'isDateNewerThan',
  isDateOlderThan = 'isDateOlderThan',
  isDateNewerThanOrEqual = 'isDateNewerThanOrEqual',
  isDateOlderThanOrEqual = 'isDateOlderThanOrEqual',
}
